/**
 * Records the visit with Matomo. Cookies are disabled, so that Matomo stores nothing on the device
 * of the visitor, and no consent is needed for it. The tracker is named by the data attributes of
 * the script element loading this module, see _Resource.cshtml.
 */
const script = document.querySelector('script[data-tracker-domain][data-site-id]');

if (script) {
  const { trackerDomain, siteId } = script.dataset,
    tracker = `https://${trackerDomain}/`,
    loader = document.createElement('script'),
    // The command queue of Matomo, which its script takes over once loaded
    queue = window._paq || []; // eslint-disable-line no-underscore-dangle

  window._paq = queue; // eslint-disable-line no-underscore-dangle

  // Before anything is tracked, so that not even the first page view sets a cookie
  queue.push(['disableCookies']);
  queue.push(['trackPageView']);
  queue.push(['enableLinkTracking']);
  queue.push(['setTrackerUrl', `${tracker}matomo.php`]);
  queue.push(['setSiteId', siteId]);

  loader.async = true;
  loader.src = `${tracker}matomo.js`;
  document.head.append(loader);
}
